var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_5774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_5774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_5774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3H33V23H3V3Z",
    fill: "#CD2A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6H33V20H3V6Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 9.44167C24.2333 12.8783 21.44 15.6583 18 15.6583C14.56 15.6583 11.7667 12.8783 11.75 9.44167C11.6105 9.97491 11.54 10.5238 11.54 11.075C11.54 14.6417 14.43 17.535 18 17.535C21.57 17.535 24.46 14.645 24.46 11.075C24.4603 10.5238 24.3897 9.97487 24.25 9.44167Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.90834L17.4387 8.63563H15.6223L17.0917 9.70354L16.5306 11.4308L18 10.3633L19.4694 11.4308L18.9083 9.70354L20.3777 8.63584H18.5612L18 6.90834Z",
    fill: "#FFC400"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_5774",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_5774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_5774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritania);
export default __webpack_public_path__ + "static/media/Mauritania.c00e5f6f3ac822846f601720b6b54764.svg";
export { ForwardRef as ReactComponent };